export class NoLabelsFoundError extends Error {}

export const isNoLabelsFoundError = (e: unknown) =>
  e instanceof NoLabelsFoundError;
